module.exports = __webpack_public_path__ + "static/media/Media.e8121e39.svg";